var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3519 1.0031C11.5099 1.16131 11.5987 1.37576 11.5987 1.59936C11.5987 1.82295 11.5099 2.0374 11.3519 2.19561L6.57066 6.97685C6.41245 7.13486 6.198 7.22361 5.97441 7.22361C5.75081 7.22361 5.53636 7.13486 5.37816 6.97685L0.596906 2.19561C0.447683 2.03569 0.36639 1.82408 0.370169 1.60539C0.373946 1.3867 0.462499 1.17802 0.617156 1.02335C0.77182 0.868698 0.980498 0.780144 1.19919 0.776367C1.41788 0.772589 1.62949 0.853882 1.78941 1.0031L5.97441 5.1881L10.1594 1.0031C10.3176 0.845098 10.5321 0.756348 10.7557 0.756348C10.9793 0.756348 11.1937 0.845098 11.3519 1.0031Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.e0f9c236d08b37d2996e9a3508b02885.svg";
export { ForwardRef as ReactComponent };